<template>
  <v-main
    v-on:drop.prevent
    class="mx-xl-12 px-xl-12 mx-md-2 px-md-2 mx-sm-2 px-sm-2 my-0 py-0"
  >
    <v-layout
      row
      mb-4
    >
      <v-flex md12>
        <div class="layout__float-left layout__padding__top-20px layout__padding__bottom-20px layout__width-100">
          <div class="text__align-center layout__padding-20-0">
            <div class="text__size-32 text__style-bold text__colour-teal layout__position-center layout__padding-20-0 layout__padding__bottom-20px">
              Update your profile
            </div>
            <div class="text__size-18 text__style-bold text__colour-teal text__line-height-12 layout__padding__bottom-20px">
              So you can get the most out of Directmailr, we just need to check a few details.<br />
              This will allow us to pre-populate as many templates for you as we can.<br />
              You will only need to complete this once.<br />
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>
    <v-form
      class="profile-width layout__margin-0-auto"
      ref="form"
      v-model="isFormValid"
      lazy-validation
    >
      <v-layout
        row
        mb-2
      >
        <v-flex
          md6
          px-4
        >
          <div class="text__align-center">
            <p class="layout__position-left text--teal text__size-20 text__style-bold layout__float-none">
              Company Logos
            </p>
          </div>
          <div class="text__size-14 text__style-bold text__colour-grey text__line-height-12 layout__padding__bottom-30px text__align-left">
            Upload your company logo for automated use in applicable templates (.jpg, .png, .tif and .pdf are
            supported).<br />
            Important: Logo quality is critical to professional printing. We recommend using a CMYK vector
            PDF.<br /><br />
            Transparent PNG's can be effective, but please check the dimensions of your logo to ensure quality can be
            maintained.<br />
            We recommend around 1200px wide, but have set a minimum of 800px wide.<br /><br />
            Please <a
            v-bind:href="this.customerHubUrl"
            target="_top"
          >contact us</a> if you have any questions or would like expert advice.<br />
          </div>
          <div class="filePickerOuter text__align-center">
            <div class="filePickerInner">
              <div
                id="varCompany_Logo_1_Image"
                class="file-picker-image"
              ></div>
              <v-file-input
                outlined
                placeholder=" "
                prepend-inner-icon="mdi-paperclip"
                prepend-icon=""
                v-model="profile.varCompany_Logo_1"
                accept=".jpg,.png,.tif,.eps,.pdf"
                :rules="[rules.required, rules.fileExists]"
                label="*Primary Company Logo (Colour)"
                @change="onLogoOrImageChange(profile.varCompany_Logo_1, 'varCompany_Logo_1_Image')"
                id="PrimaryCompanyLogoColour"
                ref="PrimaryCompanyLogoColour"
              >
              </v-file-input>
            </div>
          </div>
          <div class="filePickerOuter text__align-center">
            <div class="filePickerInner">
              <div
                id="varCompany_Logo_2_Image"
                class="file-picker-image"
              ></div>
              <v-file-input
                outlined
                placeholder=" "
                prepend-inner-icon="mdi-paperclip"
                prepend-icon=""
                v-model="profile.varCompany_Logo_2"
                accept=".jpg,.png,.tif,.eps,.pdf"
                :rules="[rules.required, rules.fileExists]"
                label="*Primary Company Logo (White)"
                @change="onLogoOrImageChange(profile.varCompany_Logo_2, 'varCompany_Logo_2_Image')"
                id="PrimaryCompanyLogoWhite"
                ref="PrimaryCompanyLogoWhite"
              >
              </v-file-input>
            </div>
          </div>
          <div class="filePickerOuter text__align-center">
            <div class="filePickerInner">
              <div
                id="varCompany_Logo_3_Image"
                class="file-picker-image"
              ></div>
              <v-file-input
                outlined
                placeholder=" "
                prepend-inner-icon="mdi-paperclip"
                prepend-icon=""
                v-model="profile.varCompany_Logo_3"
                accept=".jpg,.png,.tif,.eps,.pdf"
                :rules="[rules.fileExists]"
                label="Secondary Company Logo (Colour)"
                @change="onLogoOrImageChange(profile.varCompany_Logo_3, 'varCompany_Logo_3_Image')"
                id="SecondaryCompanyLogoColour"
                ref="SecondaryCompanyLogoColour"
              >
              </v-file-input>
            </div>
          </div>
          <div class="filePickerOuter text__align-center">
            <div class="filePickerInner">
              <div
                id="varCompany_Logo_4_Image"
                class="file-picker-image"
              ></div>
              <v-file-input
                outlined
                placeholder=" "
                prepend-inner-icon="mdi-paperclip"
                prepend-icon=""
                v-model="profile.varCompany_Logo_4"
                accept=".jpg,.png,.tif,.eps,.pdf"
                :rules="[rules.fileExists]"
                label="Secondary Company Logo (White)"
                @change="onLogoOrImageChange(profile.varCompany_Logo_4, 'varCompany_Logo_4_Image')"
                id="SecondaryCompanyLogoWhite"
                ref="SecondaryCompanyLogoWhite"
              >
              </v-file-input>
            </div>
          </div>
        </v-flex>
        <v-flex
          md6
          px-4
        >
          <div class="text__align-center">
            <p class="layout__position-left text--teal text__size-20 text__style-bold layout__float-none">Company
              Colours</p>
          </div>
          <div class="text__size-14 text__style-bold text__colour-grey text__line-height-12 layout__padding__bottom-30px text__align-left">
            Set your company colour for automated use in applicable templates. We recommend using CMYK values, though
            also accept RGB and Hex.<br /><br />
            Please note: CMYK colours may appear differently on your RGB screen. These colours will still print using
            your CMYK values and will replicate your company branding much more accurately on the final printed
            item.<br />
          </div>
          <div class="text__align-center">
            <v-text-field
              outlined
              placeholder=" "
              v-model="profile.varCompany_Colour_1"
              ref="varCompany_Colour_1"
              :rules="[rules.required]"
              label="*Company Colour - Primary"
              @click="showColourPicker1"
              @click:clear="clearColourPicker1"
              clearable
              readonly
            >
              <template v-slot:prepend-inner>
                <ColorPicker
                  v-bind:colorProp="profile.varCompany_Colour_1"
                  v-on:colorSelected1="onColourSelected1"
                  colorFieldProp="varCompany_Colour_1"
                  ref="colour_Picker_1"
                ></ColorPicker>
              </template>
            </v-text-field>
          </div>
          <div class="text__align-center">
            <v-text-field
              outlined
              placeholder=" "
              v-model="profile.varCompany_Colour_2"
              ref="varCompany_Colour_2"
              label="Company Colour - Secondary"
              @click="showColourPicker2"
              @click:clear="clearColourPicker2"
              clearable
              readonly
            >
              <template v-slot:prepend-inner>
                <ColorPicker
                  v-bind:colorProp="profile.varCompany_Colour_2"
                  v-on:colorSelected2="onColourSelected2"
                  colorFieldProp="varCompany_Colour_2"
                  ref="colour_Picker_2"
                ></ColorPicker>
              </template>
            </v-text-field>
          </div>
          <div class="text__align-center">
            <v-text-field
              outlined
              placeholder=" "
              v-model="profile.varCompany_Colour_3"
              ref="varCompany_Colour_3"
              label="Company Colour - Tertiary"
              @click="showColourPicker3"
              @click:clear="clearColourPicker3"
              clearable
              readonly
            >
              <template v-slot:prepend-inner>
                <ColorPicker
                  v-bind:colorProp="profile.varCompany_Colour_3"
                  v-on:colorSelected3="onColourSelected3"
                  colorFieldProp="varCompany_Colour_3"
                  ref="colour_Picker_3"
                ></ColorPicker>
              </template>
            </v-text-field>
          </div>
        </v-flex>
      </v-layout>

      <div>
        <v-tooltip top>
          <template>
            <p class="layout__float-left text__size-12 text__style-300">Hover here for help and advice<br />with
              branding logos and colours</p>
          </template>
          <span>
            When entering colour values manually, be sure to follow these formats:<br><br>HEX - #xxxxxx<br>RGB -
            rgba(nnn, nnn, nnn, nnn)<br>CMYK - cmyk(nnn%, nnn%, nnn%, nnn%)
          </span>
        </v-tooltip>
      </div>

      <div
        class="layout__padding__top-10px"
        v-show="!isCalledFromMenu"
      >
        <div class="text__align-center">
          <el-button
            class="button__base layout__width-200px button__background-red layout__cursor-pointer"
            v-on:click="update('continue')"
          >Continue
          </el-button>
        </div>
      </div>

      <div
        class="layout__padding__top-10px"
        v-show="isCalledFromMenu"
      >
        <div class="text__align-center">
          <el-button
            class="button__base layout__width-200px button__background-red layout__cursor-pointer"
            v-on:click="update('save')"
          >Save
          </el-button>
        </div>
      </div>

      <v-snackbar
        v-model="saveProfileSuccess"
        color="success"
        :top="true"
        :timeout="5000"
      >
        Your profile changes have been saved successfully.
        <v-btn
          text
          @click="saveProfileSuccess = false"
        >
          Close
        </v-btn>
      </v-snackbar>

      <v-snackbar
        v-model="saveProfileFailure"
        color="error"
        :top="true"
        :timeout="5000"
      >
        Sorry there has been a problem saving your profile changes. Please try again.
        <v-btn
          text
          @click="saveProfileFailure = false"
        >
          Close
        </v-btn>
      </v-snackbar>

      <v-overlay :value="loading">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </v-form>
  </v-main>
</template>

<script>
import Router from '../../router.js';
import Axios from 'axios';
import { axios } from '@/mixins/Axios.js';
import ColorPicker from '@/components/instant_marketing_comps/ColorPicker';
//import {pdfjsLib} from "../../node-modules/pdfjs-dist/es5/build/pdf.js";
//import {pdfjsLib} from "pdfjs-dist";
import * as pdfjsLib from 'pdfjs-dist/es5/build/pdf.js';
//import 'pdfjs-dist/build/pdf.worker.js';
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.js`;
//pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdn.bootcss.com/pdf.js/2.2.228/pdf.worker.js';
//pdfjsLib.GlobalWorkerOptions.workerSrc = '../../node-modules/pdfjs-dist/es5/build/pdf.worker.js';

export default {
  data() {
    return {
      profile: {
        customerRef: '',
        organisationId: 0,
        varCompany_Logo_1: null,
        varCompany_Logo_2: null,
        varCompany_Logo_3: null,
        varCompany_Logo_4: null,
        varCompany_Colour_1: '',
        varCompany_Colour_2: '',
        varCompany_Colour_3: '',
        varBranch_Company_Name: '',
        varBranch_Company_Brand: '',
        varBranch_Name: '',
        varBranch_Email: '',
        varBranch_Telephone: '',
        varBranch_Web_Address: '',
        varBranch_Address_1: '',
        varBranch_Address_2: '',
        varBranch_Address_3: '',
        varBranch_Town: '',
        varBranch_County: '',
        varBranch_PostCode: '',
        varBranch_FullAddress: '',
        varUser_FirstName: '',
        varUser_Surname: '',
        varUser_FullName: '',
        varUser_Email: '',
        varUser_Telephone: '',
        varUser_Job_Title: '',
        varUser_Mobile: '',
        varUser_Info_1: '',
        varUser_Info_2: '',
        varUser_Info_3: '',
        varUser_Info_4: '',
        varUser_Info_5: '',
        varUser_Info_6: '',
      },
      loading: false,
      isFormValid: false,
      isCalledFromMenu: false,
      saveProfileSuccess: false,
      saveProfileFailure: false,
      type: 'hex',
      hex: '#FF00FF',
      companyLogoPrimaryColour: '',
      companyLogoPrimaryWhite: '',
      companyLogoSecondaryColour: '',
      companyLogoSecondaryWhite: '',
      doNotReloadLogo: false,
      customerHubUrl: '',
      directmailrUrl: '',
      accountsApiHostUrl: `${process.env.VUE_APP_ACCOUNTSAPIHOST}`,
      customer: {},
      templatingValues: {},
      user: {},
      rules: {
        required: value => !! value || 'Required field',
        fileExists: value => value !== 'missed' || 'Looks like file is missed. Please, upload the new one',
        // email: value => {
        //     const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        //     return pattern.test(value) || 'Invalid email address'
        // },
      },
    };
  },
  components: {
    ColorPicker
  },
  mixins: [axios],
  computed: {},
  created() {
    this.customerHubUrl = `${process.env.VUE_APP_CUSTOMERHUBUIHOST}/contact`;
    this.directmailrUrl = `${process.env.VUE_APP_CUSTOMERHUBUIHOST}/directmailr`;

    console.log('customer hub url ' + this.customerHubUrl);
    console.log('directmailr url ' + this.directmailrUrl);
  },
  async mounted() {
    this.loading = true;
    // let valid = true;

    this.customer = JSON.parse(window.sessionStorage.getItem('customer'));
    this.templatingValues = JSON.parse(window.sessionStorage.getItem('templatingValues'));
    this.user = JSON.parse(window.sessionStorage.getItem('user'));

    this.profile.customerRef = this.customer.ref;
    this.profile.organisationId = this.templatingValues.organisationId;

    //Compamy
    this.profile.varBranch_Company_Name = this.templatingValues.varUser_Company_Name;
    this.profile.varBranch_Company_Brand = this.templatingValues.varUser_Company_Brand;

    if (this.templatingValues.varCompany_Logo_1 !== undefined) {
      try {
        this.profile.varCompany_Logo_1 = await this.getLogoOrImage(this.templatingValues.varCompany_Logo_1, 'varCompany_Logo_1_Image');
      } catch {
        this.profile.varCompany_Logo_1 = 'missed';
      }
      // if (this.profile.varCompany_Logo_1 === '') {
      //     valid = false;
      // }
    }

    if (this.templatingValues.varCompany_Logo_2 !== undefined) {
      try {
        this.profile.varCompany_Logo_2 = await this.getLogoOrImage(this.templatingValues.varCompany_Logo_2, 'varCompany_Logo_2_Image');
      } catch {
        this.profile.varCompany_Logo_2 = 'missed';
      }
      // if (this.profile.varCompany_Logo_2 === '') {
      //     valid = false;
      // }
    }

    if (this.templatingValues.varCompany_Logo_3 !== undefined) {
      try {
        this.profile.varCompany_Logo_3 = await this.getLogoOrImage(this.templatingValues.varCompany_Logo_3, 'varCompany_Logo_3_Image');
      } catch {
        this.profile.varCompany_Logo_3 = 'missed';
      }
      // if (this.profile.varCompany_Logo_3 === '') {
      //     valid = false;
      // }
    }

    if (this.templatingValues.varCompany_Logo_4 !== undefined) {
      try {
        this.profile.varCompany_Logo_4 = await this.getLogoOrImage(this.templatingValues.varCompany_Logo_4, 'varCompany_Logo_4_Image');
      } catch {
        this.profile.varCompany_Logo_4 = 'missed';
      }

      // if (this.profile.varCompany_Logo_4 === '') {
      //     valid = false;
      // }
    }

    if (this.templatingValues.varCompany_Colour_1 !== undefined) {
      this.profile.varCompany_Colour_1 = this.templatingValues.varCompany_Colour_1;
      // if (this.profile.varCompany_Colour_1 === '') {
      //     valid = false;
      // }

      this.setColourPicker1(this.profile.varCompany_Colour_1);
    }

    if (this.templatingValues.varCompany_Colour_2 !== undefined) {
      this.profile.varCompany_Colour_2 = this.templatingValues.varCompany_Colour_2;
      // if (this.profile.varCompany_Colour_2 === '') {
      //     valid = false;
      // }

      this.setColourPicker2(this.profile.varCompany_Colour_2);
    }

    if (this.templatingValues.varCompany_Colour_3 !== undefined) {
      this.profile.varCompany_Colour_3 = this.templatingValues.varCompany_Colour_3;
      // if (this.profile.varCompany_Colour_3 === '') {
      //     valid = false;
      // }

      this.setColourPicker3(this.profile.varCompany_Colour_3);
    }

    //Branch
    this.profile.varBranch_Name = this.templatingValues.varUser_Branch_Name;
    this.profile.varBranch_Email = this.templatingValues.varUser_Email;
    this.profile.varBranch_Telephone = this.templatingValues.varUser_Telephone;
    this.profile.varBranch_Web_Address = this.templatingValues.varUser_Web_Address;
    this.profile.varBranch_Address_1 = this.templatingValues.varUser_Address_1;
    this.profile.varBranch_Address_2 = this.templatingValues.varUser_Address_2;
    this.profile.varBranch_Address_3 = this.templatingValues.varUser_Address_3;
    this.profile.varBranch_Town = this.templatingValues.varUser_Town;
    this.profile.varBranch_County = this.templatingValues.varUser_County;
    this.profile.varBranch_PostCode = this.templatingValues.varUser_PostCode;

    //User
    this.profile.varUser_FirstName = this.user.name;
    this.profile.varUser_Surname = this.user.surname;
    this.profile.varUser_Telephone = this.templatingValues.varUser_Telephone;

    this.profile.varUser_Email = this.user.emailAddress;

    // console.log('valid=' + valid);

    parent.postMessage('ScrollIntoView', '*');

    this.loading = false;

    // if (valid) {
    console.log('_showProfile=' + window.sessionStorage.getItem('_showProfile'));
    var showProfile = window.sessionStorage.getItem('_showProfile');

    if (showProfile !== undefined && showProfile !== null) {
      // sessionStorage.setItem('_showProfile', this.$route.query.showProfile);
      window.sessionStorage.removeItem('_showProfile');
      this.isCalledFromMenu = true;
    }

    //     if (window.sessionStorage.getItem('_showProfile') === null) {
    //         this.navigate('fulfilment');
    //     } else {
    //         this.$refs.form.validate();
    //         window.sessionStorage.removeItem('_showProfile');
    //     }
    // } else {
    this.$refs.form.validate();
    // }
  },
  methods: {
    navigate(path) {
      Router.push({
        path: '/' + path,
      });
    },
    update(method) {
      console.log('update: ' + method);

      this.$refs.form.validate();

      console.log('update');
      console.log('isFormValid=' + this.isFormValid);
      console.log(this.profile);

      if (! this.isFormValid) {
        return;
      }

      window.sessionStorage.setItem('customer', JSON.stringify(this.customer));
      window.sessionStorage.setItem('templatingValues', JSON.stringify(this.templatingValues));
      window.sessionStorage.setItem('user', JSON.stringify(this.user));

      this.profile.varBranch_FullAddress = this.profile.varBranch_Address_1;
      if (this.profile.varBranch_Address_2 != '') {
        this.profile.varBranch_FullAddress += ', ' + this.profile.varBranch_Address_2;
      }
      if (this.profile.varBranch_Address_3 != '') {
        this.profile.varBranch_FullAddress += ', ' + this.profile.varBranch_Address_3;
      }
      this.profile.varBranch_FullAddress += ', ' + this.profile.varBranch_Town;
      if (this.profile.varBranch_County != '') {
        this.profile.varBranch_FullAddress += ', ' + this.profile.varBranch_County;
      }
      this.profile.varBranch_FullAddress += ' ' + this.profile.varBranch_PostCode;
      console.log('varBranch_FullAddress=' + this.profile.varBranch_FullAddress);

      var company_Logo_1;

      if (this.profile.varCompany_Logo_1 == null) {
        company_Logo_1 = '';
      } else {
        company_Logo_1 = this.profile.varCompany_Logo_1.name;
      }

      var company_Logo_2;

      if (this.profile.varCompany_Logo_2 == null) {
        company_Logo_2 = '';
      } else {
        company_Logo_2 = this.profile.varCompany_Logo_2.name;
      }

      var company_Logo_3;

      if (this.profile.varCompany_Logo_3 == null) {
        company_Logo_3 = '';
      } else {
        company_Logo_3 = this.profile.varCompany_Logo_3.name;
      }

      var company_Logo_4;

      if (this.profile.varCompany_Logo_4 == null) {
        company_Logo_4 = '';
      } else {
        company_Logo_4 = this.profile.varCompany_Logo_4.name;
      }

      var updatedValues = {
        'customerRef': this.profile.customerRef,
        'organisationId': this.profile.organisationId,
        'varCompany_Logo_1': company_Logo_1,
        'varCompany_Logo_2': company_Logo_2,
        'varCompany_Logo_3': company_Logo_3,
        'varCompany_Logo_4': company_Logo_4,
        'varCompany_Colour_1': this.profile.varCompany_Colour_1,
        'varCompany_Colour_2': this.profile.varCompany_Colour_2,
        'varCompany_Colour_3': this.profile.varCompany_Colour_3,
        'varUser_Company_Name': this.profile.varBranch_Company_Name,
        'varUser_Company_Brand': this.profile.varBranch_Company_Brand,
        'varUser_Branch_Name': this.profile.varBranch_Name,
        'varUser_Email': this.profile.varBranch_Email,
        'varUser_Telephone': this.profile.varBranch_Telephone,
        'varUser_Web_Address': this.profile.varBranch_Web_Address,
        'varUser_Address_1': this.profile.varBranch_Address_1,
        'varUser_Address_2': this.profile.varBranch_Address_2,
        'varUser_Address_3': this.profile.varBranch_Address_3,
        'varUser_Town': this.profile.varBranch_Town,
        'varUser_County': this.profile.varBranch_County,
        'varUser_PostCode': this.profile.varBranch_PostCode,
        'varUser_FullAddress': this.profile.varBranch_FullAddress
      };

      console.log(updatedValues);

      this.loading = true;

      var endpoint = this.accountsApiHostUrl + '/api/services/app/Customer/UpdateTemplatingValues';
      Axios.put(endpoint, updatedValues, this.returnHeaderNoToken())
        .then(response => {
          console.log(response.data);

          window.sessionStorage.setItem('templatingValues', JSON.stringify(this.templatingValues));

          this.loading = false;

          if (method == 'continue') {
            this.navigate('fulfilment');
          } else {
            var orderId = window.sessionStorage.getItem('_order_id');

            if (orderId === undefined || orderId === null) {
              this.saveProfileSuccess = true;
              window.parent.location.href = this.directmailrUrl;
            } else {
              const getJobUrl = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder/` + orderId;

              Axios.get(getJobUrl, this.returnHeaderUsingToken())
                .then(response => {
                  console.log(response.data);
                  var directmailrOrder = response.data[0];

                  if (directmailrOrder.dataUrl === null) {
                    if (directmailrOrder.dataProvider === 'Databook') {
                      this.navigate('select-data-databook');
                    }

                    if (directmailrOrder.dataProvider === 'Leadhub') {
                      this.navigate('select-data-leadhub');
                    }
                  } else {
                    if (directmailrOrder.printJobSpec.quantity === 0) {
                      this.navigate('data-preview');
                    } else {
                      if (directmailrOrder.templateId === null) {
                        this.navigate('select-design-type');
                      } else {
                        if (directmailrOrder.imageUrl === null) {
                          this.navigate('personalise-design');
                        } else {
                          if (directmailrOrder.productPriceCode === null || directmailrOrder.productPriceCode === '') {
                            this.navigate('print-options');
                          } else {
                            this.navigate('checkout');
                          }
                        }
                      }
                    }
                  }
                });
            }
          }

          return;
        })
        .catch(error => {
          event.stopPropagation();

          this.loading = false;
          this.saveProfileFailure = true;
        });
    },
    async getLogoOrImage(logo, image) {
      console.log('getLogoOrImage');
      console.log('logo=' + logo);

      if (logo === null) {
        return;
      }

      let filename = logo,
        ext = filename.substr(filename.lastIndexOf('.') + 1),
        filename_small = filename.replace('.' + ext, '');

      console.log('logo=' + logo);

      var output = document.getElementById(image);

      if (ext == 'pdf') {
        const worker = new pdfjsLib.PDFWorker();
        let pdf = await pdfjsLib
          .getDocument({ url: logo, worker: worker })
          .promise.then((pdf) => pdf);
        var pageNumber = 1;
        const page = await pdf.getPage(pageNumber);

        console.log('Page loaded');
        var scale = 1.0;
        var viewport = page.getViewport({ scale: scale });

        // Prepare canvas using PDF page dimensions
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        console.log('viewport.height: ' + viewport.height);
        console.log('viewport.width: ' + viewport.width);
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // Render PDF page into canvas context
        var renderContext = {
          canvasContext: context,
          viewport: viewport
        };
        var renderTask = page.render(renderContext);
        renderTask.promise.then(function () {
          var img_src = canvas.toDataURL();
          output.innerHTML = '';
          var img = new Image();
          img.src = img_src;
          img.style.maxHeight = '100px';
          img.style.maxWidth = '450px';
          img.style.height = '100%';
          img.style.width = '100%';
          img.style['object-fit'] = 'scale-down';

          output.appendChild(img);

          console.log('Page rendered');
        });

        // let viewport = page.getViewport({ scale: 1.0 })
        // var scale = 1.0;
        // viewport = page.getViewport({ scale: scale })
        // let canvas = document.getElementById(this._uid)
        // canvas.height = viewport.height
        // canvas.width = viewport.width
        // const context = canvas.getContext('2d')
        // await page.render({ canvasContext: context, viewport: viewport })


        // var loadingTask = pdfjsLib.getDocument(logo);
        // loadingTask.promise.then(function(pdf) {
        //     console.log('PDF loaded');

        //     // Fetch the first page
        //     var pageNumber = 1;
        //     pdf.getPage(pageNumber).then(function(page) {
        //         console.log('Page loaded');
        //     var scale = 1.0;
        //     var viewport = page.getViewport({scale: scale});

        //     // Prepare canvas using PDF page dimensions
        //     var canvas = document.createElement('canvas');
        //     var context = canvas.getContext('2d');
        //     console.log('viewport.height: ' + viewport.height);
        //     console.log('viewport.width: ' + viewport.width);
        //     canvas.height = viewport.height;
        //     canvas.width = viewport.width;

        //     // Render PDF page into canvas context
        //     var renderContext = {
        //         canvasContext: context,
        //         viewport: viewport
        //     };
        //     var renderTask = page.render(renderContext);
        //     renderTask.promise.then(function () {
        //         var img_src = canvas.toDataURL();
        //         output.innerHTML = '';
        //         var img = new Image();
        //         img.src = img_src;
        //         img.style.maxHeight = '100px';
        //         img.style.maxWidth = '450px';
        //         output.appendChild(img);

        //         console.log('Page rendered');
        //     });
        // },
        // error => console.log('Error', error),
        // )
        // }, function (reason) {
        //     // PDF loading error
        //     console.error(reason);
        // });
        // import('pdfjs-dist/webpack').then(pdfjsLib => {
        // pdfjsLib
        //     .getDocument(logo)
        //     .then(pdf => {
        //     const pagePromises = pdf.getPage(1)
        //     return Promise.all(pagePromises)
        //     })
        //     .then(page => {
        //         console.log('Page loaded');

        //         var scale = 1.0;
        //         var viewport = page.getViewport({scale: scale});

        //         // Prepare canvas using PDF page dimensions
        //         var canvas = document.createElement('canvas');
        //         var context = canvas.getContext('2d');
        //         console.log('viewport.height: ' + viewport.height);
        //         console.log('viewport.width: ' + viewport.width);
        //         canvas.height = viewport.height;
        //         canvas.width = viewport.width;

        //         // Render PDF page into canvas context
        //         var renderContext = {
        //             canvasContext: context,
        //             viewport: viewport
        //         };
        //         var renderTask = page.render(renderContext);
        //         renderTask.promise.then(function () {
        //             var img_src = canvas.toDataURL();
        //             output.innerHTML = '';
        //             var img = new Image();
        //             img.src = img_src;
        //             img.style.maxHeight = '100px';
        //             img.style.maxWidth = '450px';
        //             output.appendChild(img);

        //             console.log('Page rendered');
        //         });
        //     },
        //     error => console.log('Error', error),
        //     )
        // })
      } else {
        output.innerHTML = '';
        var img = new Image();
        img.src = logo;
        img.style.maxHeight = '100px';
        img.style.maxWidth = '450px';
        img.style.height = '100%';
        img.style.width = '100%';
        img.style['object-fit'] = 'scale-down';
        output.appendChild(img);
      }

      return new File([filename_small], filename, { type: 'application/pdf' });
    },
    async onLogoOrImageChange(logo, image) {
      console.log('this.doNotReloadLogo=' + this.doNotReloadLogo);
      if (this.doNotReloadLogo) {
        this.doNotReloadLogo = false;
        return;
      }

      console.log('logo=' + logo);
      console.log('image=' + image);

      if (logo !== null) {
        await this.postFile(logo, image);
      }
    },
    async postFile(file, logo) {
      console.log('postFile');

      if (file.name !== undefined) {
        this.loading = true;

        console.log('file.name=' + file.name);

        let formData = new FormData();
        formData.append(file.name, file, file.name);

        const uploadFile = `${process.env.VUE_APP_UPLOADAPIHOST}/api/upload/UploadInstantMarketingLogo`;
        //const uploadFile = `${process.env.VUE_APP_INTERNAL_ACCOUNTS}/api/upload/UploadInstantMarketingLogo`
        //const uploadFile = `https://devtkaccountsapi.azurewebsites.net/api/upload/UploadInstantMarketingLogo`

        await Axios.post(uploadFile, formData, {
          headers: {
            'content-type': 'multipart/form-data',
            'Access-Control-Allow-Origin': '*',
            'Authorization': 'Bearer ' + this.returnCookie('_auth_token')
          },
          // headers: {
          //     "content-type": "multipart/form-data",
          //     "Access-Control-Allow-Origin": "*"
          // },
          onUploadProgress: function (uploadEvent) {
            this.uploadPercentage = Math.round(uploadEvent.loaded / uploadEvent.total * 100);
          }.bind(this)
        })
          .then(async response => {
            console.log(response);
            console.log(response.data[0]);
            console.log(response.data[0].storageUri);

            switch (logo) {
              case 'varCompany_Logo_1_Image':
                console.log('within switch');
                this.doNotReloadLogo = true;
                this.templatingValues.varCompany_Logo_1 = response.data[0].storageUri;
                console.log('this.doNotReloadLogo=' + this.doNotReloadLogo);
                this.profile.varCompany_Logo_1 = await this.getLogoOrImage(this.templatingValues.varCompany_Logo_1, logo);
                this.$refs.PrimaryCompanyLogoColour.blur(); //this gets around the bug about reloading a file x2

                break;
              case 'varCompany_Logo_2_Image':
                this.doNotReloadLogo = true;
                this.templatingValues.varCompany_Logo_2 = response.data[0].storageUri;
                this.profile.varCompany_Logo_2 = await this.getLogoOrImage(this.templatingValues.varCompany_Logo_2, logo);
                this.$refs.PrimaryCompanyLogoWhite.blur(); //this gets around the bug about reloading a file x2

                break;
              case 'varCompany_Logo_3_Image':
                this.doNotReloadLogo = true;
                this.templatingValues.varCompany_Logo_3 = response.data[0].storageUri;
                this.profile.varCompany_Logo_3 = await this.getLogoOrImage(this.templatingValues.varCompany_Logo_3, logo);
                this.$refs.SecondaryCompanyLogoColour.blur(); //this gets around the bug about reloading a file x2

                break;
              case 'varCompany_Logo_4_Image':
                this.doNotReloadLogo = true;
                this.templatingValues.varCompany_Logo_4 = response.data[0].storageUri;
                this.profile.varCompany_Logo_4 = await this.getLogoOrImage(this.templatingValues.varCompany_Logo_4, logo);
                this.$refs.SecondaryCompanyLogoWhite.blur(); //this gets around the bug about reloading a file x2

                break;
            }

            window.sessionStorage.setItem('templatingValues', JSON.stringify(this.templatingValues));

            this.loading = false;
          })
          .catch(error => {
            console.log(error);

            this.loading = false;
          });
      }
    },
    showColourPicker1() {
      this.$refs.colour_Picker_1.pickr.show();
    },
    setColourPicker1(colour) {
      console.log(colour.toString());

      if (colour == null) {
        this.$refs.colour_Picker_1.pickr.setColorRepresentation('CMYK');
      } else {
        if (colour.toString().substring(0, 4) == 'cmyk') {
          this.$refs.colour_Picker_1.pickr.setColorRepresentation('CMYK');
        } else if (colour.toString().substring(0, 4) == 'rgba') {
          this.$refs.colour_Picker_1.pickr.setColorRepresentation('RGBA');
        } else { //hex
          this.$refs.colour_Picker_1.pickr.setColorRepresentation('HEX');
        }
      }

      this.$refs.colour_Picker_1.pickr.setColor(colour);
    },
    clearColourPicker1() {
      this.$refs.colour_Picker_1.pickr.setColor(null);
    },
    showColourPicker2() {
      this.$refs.colour_Picker_2.pickr.show();
    },
    setColourPicker2(colour) {
      console.log(colour.toString());

      if (colour == null) {
        this.$refs.colour_Picker_2.pickr.setColorRepresentation('CMYK');
      } else {
        if (colour.toString().substring(0, 4) == 'cmyk') {
          this.$refs.colour_Picker_2.pickr.setColorRepresentation('CMYK');
        } else if (colour.toString().substring(0, 4) == 'rgba') {
          this.$refs.colour_Picker_2.pickr.setColorRepresentation('RGBA');
        } else { //hex
          this.$refs.colour_Picker_2.pickr.setColorRepresentation('HEX');
        }
      }

      this.$refs.colour_Picker_2.pickr.setColor(colour);
    },
    clearColourPicker2() {
      this.$refs.colour_Picker_2.pickr.setColor(null);
    },
    showColourPicker3() {
      this.$refs.colour_Picker_3.pickr.show();
    },
    setColourPicker3(colour) {
      console.log(colour.toString());

      if (colour == null) {
        this.$refs.colour_Picker_3.pickr.setColorRepresentation('CMYK');
      } else {
        if (colour.toString().substring(0, 4) == 'cmyk') {
          this.$refs.colour_Picker_3.pickr.setColorRepresentation('CMYK');
        } else if (colour.toString().substring(0, 4) == 'rgba') {
          this.$refs.colour_Picker_3.pickr.setColorRepresentation('RGBA');
        } else { //hex
          this.$refs.colour_Picker_3.pickr.setColorRepresentation('HEX');
        }
      }

      this.$refs.colour_Picker_3.pickr.setColor(colour);
    },
    clearColourPicker3() {
      this.$refs.colour_Picker_3.pickr.setColor(null);
    },
    onColourSelected1(value) {
      console.log('value: ' + value);

      if (value == null) {
        this.profile.varCompany_Colour_1 = '';
      } else {
        this.profile.varCompany_Colour_1 = this.formatColour(value);
      }

      this.templatingValues.varCompany_Colour_1 = this.profile.varCompany_Colour_1;
    },
    onColourSelected2(value) {
      console.log('value: ' + value);

      if (value == null) {
        this.profile.varCompany_Colour_2 = '';
      } else {
        this.profile.varCompany_Colour_2 = this.formatColour(value);
      }

      this.templatingValues.varCompany_Colour_2 = this.profile.varCompany_Colour_2;
    },
    onColourSelected3(value) {
      console.log('value: ' + value);

      if (value == null) {
        this.profile.varCompany_Colour_3 = '';
      } else {
        this.profile.varCompany_Colour_3 = this.formatColour(value);
      }

      this.templatingValues.varCompany_Colour_3 = this.profile.varCompany_Colour_3;
    },
    formatColour(value) {
      var string = '';

      if (value.toString().substring(0, 4) == 'cmyk') {
        string = 'cmyk(' + value[0].toFixed(0).toString() + '%, ';
        string += value[1].toFixed(0).toString() + '%, ';
        string += value[2].toFixed(0).toString() + '%, ';
        string += value[3].toFixed(0).toString() + '%)';
      } else if (value.toString().substring(0, 4) == 'rgba') {
        string = 'rgba(' + value[0].toFixed(0).toString() + ', ';
        string += value[1].toFixed(0).toString() + ', ';
        string += value[2].toFixed(0).toString() + ', ';
        string += value[3].toFixed(0).toString() + ')';
      } else { //hex
        string = '#' + value[0].toString().toUpperCase();
        string += value[1].toString().toUpperCase();
        string += value[2].toString().toUpperCase();
      }

      console.log('string: ' + string);
      return string;
    }
  }
};
</script>